"use strict";

var AnimationType, AutoPlayStrategy, ControlsStrategy, AutoplayDirection;
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.AutoplayDirection = exports.ControlsStrategy = exports.AutoPlayStrategy = exports.AnimationType = void 0, function (t) {
  t.FADEOUT = "fadeout", t.SLIDE = "slide";
}(AnimationType = exports.AnimationType || (exports.AnimationType = {})), function (t) {
  t.DEFAULT = "default", t.ALL = "all", t.ACTION = "action", t.NONE = "none";
}(AutoPlayStrategy = exports.AutoPlayStrategy || (exports.AutoPlayStrategy = {})), function (t) {
  t.DEFAULT = "default", t.RESPONSIVE = "responsive";
}(ControlsStrategy = exports.ControlsStrategy || (exports.ControlsStrategy = {})), function (t) {
  t.RTL = "rtl", t.LTR = "ltr";
}(AutoplayDirection = exports.AutoplayDirection || (exports.AutoplayDirection = {}));